<template>
  <div>
    <mainHeader></mainHeader>
    <testPortalBanner v-if="isTestPortal"></testPortalBanner>
    <sideMenu :studyData="studyData" :isTestPortal="isTestPortal"></sideMenu>
    <div class="has-sidemenu has-header" :class="{ 'test-portal-padding-reset': isTestPortal }">
      <router-view :studyData="studyData" :studyId="studyId" :siteId="siteId"></router-view>
    </div>
  </div>
</template>

<script>
import mainHeader from "@/components/common/main-header";
import testPortalBanner from "@/components/common/test-portal-banner";
import sideMenu from "@/components/common/side-menu";
import localStorageService from "@/services/localStorage";

export default {
  name: "site-team",
  components: {
    mainHeader,
    testPortalBanner,
    sideMenu
  },
  data() {
    return {
      studyData: {}
    };
  },
  props: {
    isTestPortal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    studyId() {
      return this.$route.params.studyId;
    },
    siteId() {
      return this.$route.params.siteId;
    }
  },
  mounted() {
    try {
      this.studyData = localStorageService.getItem("studyDetailsData")[this.studyId] || {};
    } catch {
      this.studyData = {};
    }
  }
};
</script>
